module.exports = __webpack_public_path__ + "static/media/times-square.b8cafd0d.svg";